import types from "./types";

const initialState = {
  loading: false,
  error: null,
  success: null,
  cartridgeAlternatives: [],
  editedAlternative: null,
};

const alternativesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    case types.CLEAR_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case types.ALTERNATIVES_NEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case types.ALTERNATIVES_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: "New alternative added",
      };
    case types.ALTERNATIVES_NEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: "Could not create new alternative",
        success: null,
      };
    case types.ALTERNATIVES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
        cartridgeAlternatives: [],
      };
    case types.ALTERNATIVES_FAILURE:
      return {
        ...state,
        loading: false,
        error: "Could not fetch alternatives, please try again",
        success: null,
        cartridgeAlternatives: [],
      };
    case types.ALTERNATIVES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        cartridgeAlternatives: action.payload,
      };
    case types.CARTRIDGE_ALTTERNATIVE_EDIT:
      return {
        ...state,
        editedAlternative: action.payload,
      };
    case types.ALTERNATIVES_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: "Alternative Deleted Successfully",
      };

    default:
      return state;
  }
};

export default alternativesReducer;
